(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('#shopify-section-header, .section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // BJP-113 — hide/reveal triggers IMMEDIATELY on any scroll past
      // the very top (scrollTop > 0), not only after the user clears
      // the full header height. Dawn's default used `> this.headerBounds.bottom`
      // (header height ≈ 80–150px) which felt sluggish — the header
      // lingered on screen for the first half-second of a scroll. The
      // ticket asks for an instant hide on scroll-down, so we drop the
      // bound and gate on `> 0` instead so the reset state (transparent
      // ghost at the very top of the homepage) is still reachable.
      if (scrollTop > this.currentScrollTop && scrollTop > 0) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > 0) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= 0) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('header-pinned');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('header-pinned');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('header-pinned');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      // This theme replaces Dawn's <details-modal> search with the
      // header-search drawer, so the modal may not exist — guard against
      // null or every scroll-down throws (StickyHeader.hide → here).
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* BJP-140 round 12 (Parker feedback 2026-07-13) — sync fix for
   * mobile drawer + X icon.
   *
   * Root cause (rounds 9-11 all failed): Dawn's `MenuDrawer.
   * openMenuDrawer()` uses `setTimeout(fn)` to defer adding the
   * `.menu-opening` class by ~4ms. During those 4ms, Dawn expects
   * both `<summary>` and `<div class="menu-drawer">` to already
   * have their `[open]`-state layout (position: fixed at -100%
   * translateX) painted so the transform transition can interpolate.
   *
   * But Chrome/Safari don't fire transitions when an element just
   * STARTED matching a rule with a new transform value (no previous
   * transform to interpolate FROM) — they paint at the target
   * instantly. So the summary jumps to translateX(-100%) instantly
   * (invisible) then jumps to 0 when .menu-opening lands, while the
   * drawer's translateX(-100%) → 0 does properly transition (its
   * base rule was always matching with that transform value).
   *
   * Fix: add `.menu-opening` SYNCHRONOUSLY with [open] via the click
   * handler, so both classes land in the SAME frame. Once
   * .menu-opening is present from frame 0, CSS transition on both
   * summary and drawer fires from base (-100%) → menu-opening (0)
   * consistently.
   *
   * On close (Dawn's closeMenuDrawer): .menu-opening removed
   * immediately, [open] removed 400ms later via closeAnimation loop.
   * Base rule matches through the whole close window, transition
   * plays out normally. We don't need to change this path — Dawn's
   * mechanism already works for close. */
  (function syncMenuOpeningWithOpen() {
    if (!customElements.get('header-drawer')) return;

    document.addEventListener('click', function (event) {
      const summary = event.target.closest('summary.header__icon--menu');
      if (!summary) return;

      const details = summary.parentElement;
      if (!details || !details.classList.contains('menu-drawer-container')) return;

      /* Round 17 v2 — verified via Chrome inspection (2026-07-13):
       * even `Promise.resolve().then()` (microtask) loses the race
       * with paint on some real-user click sequences. At the first
       * paint after click, `[open]` is set but `.menu-opening` is
       * NOT — the CSS rule
       *     `.menu-drawer-container[open]:not(.menu-opening) > summary
       *       { animation: pd-drawer-summary-slide-out ... forwards }`
       * matches for that one frame, animation starts at its `from`
       * state (translateX(0)) so the X bar paints full-width at the
       * top of the viewport for 1 frame — the flash Parker sees.
       *
       * Fix: add `.menu-opening` SYNCHRONOUSLY in this capture
       * handler, BEFORE the native <details> default action toggles
       * `[open]`. Event order for a `<summary>` click is:
       *   1. Capture-phase listeners (this handler)
       *   2. Bubble-phase listeners
       *   3. Default action (toggle `[open]`)
       *   4. Task ends → microtasks → paint
       * So by adding `.menu-opening` in step 1, it lands in the DOM
       * before step 3 sets `[open]`. Step 4 paints the frame with
       * BOTH classes present → slide-in animation fires cleanly
       * from translateX(-100%) → translateX(0). No flash frame. */
      if (!details.hasAttribute('open')) {
        details.classList.add('menu-opening');
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
